<template>
  <div class="container">
    <el-row>
      <el-col :span="3">
        <cma-catalog :site-type="this.site_type" :project-id="this.project_id" :site-id="this.site_id"
                     :rr-type="this.rr_type" title="原始记录（CMA）"
                     :route-name="'site_'+this.site_type+'_list'"></cma-catalog>
      </el-col>
      <el-col :span="21">
        <Toolbar
            :inspectStatus="inspect_status"
            :buttons="[
              {text:'保存', type: 'success', onClick: handleSubmit},
              {text:'生成整改建议', type: 'primary', onClick: handleGenerateContent},
            ]"
            :currentRoute="currentRoute"
            :projectId="project_id"
            :siteId="site_id"
            :siteType="site_type"
        />
        <hr>
        <p>检测结果汇总及整改建议</p>
        <el-form :model="form">
          <table>
            <tr>
              <td>
                <el-input type="textarea" :rows="30" placeholder="请输入内容" v-model="form.jczs"></el-input>
              </td>
            </tr>
          </table>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Toolbar from "@/components/Toolbar.vue";

export default {
  components: {Toolbar},
  data() {
    return {
      currentRoute: 'record_cma_index',
      site_id: '',
      project_id: '',
      site_type: '',
      rr_type: 'record',
      inspect_status: false,
      form: {
        jczs: ''
      }
    }
  },
  methods: {
    async getData() {
      try {
        let params = {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type
        }
        let res = await this.$Api.post('get_record_cma_jczs', params)
        if (res) {
          this.form.jczs = res.jczs
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //生成整改建议
    async handleGenerateContent() {
      try {
        await this.$Api.post('generate_record_cma_zgjy', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type
        })
        await this.getData()
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //保存
    async handleSubmit() {
      try {
        let params = this.form
        params.project_id = this.project_id
        params.site_id = this.site_id
        await this.$Api.post('edit_record_cma_jczs', params)
        this.$message.success('修改成功')
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    },
    //设置操作按钮的状态
    async setButtonStatus() {
      try {
        let res = await this.$Api.post('get_site_status', {
          project_id: this.project_id,
          site_id: this.site_id,
          site_type: this.site_type,
          status_type: 'cma'
        })
        if (res) {
          if (res === '检测中' || res === '已完成') {
            this.inspect_status = true
          }
        }
      } catch (e) {
        this.$message.error(e.errormsg)
      }
    }
  },
  created() {
    this.project_id = this.$route.params.project_id
    this.site_id = this.$route.params.site_id
    this.site_type = this.$route.params.site_type
    this.setButtonStatus()
    this.getData()
  }
}
</script>
<style scoped>
table {
  width: 88%;
  margin-left: 50px;
}

p {
  text-align: center;
}

table, table tr td {
  border: 1px solid black;
  border-collapse: collapse;
}
</style>
